import { render, staticRenderFns } from "./SecondGradAndTransferResult.vue?vue&type=template&id=a83f18fe&scoped=true&"
import script from "./SecondGradAndTransferResult.vue?vue&type=script&lang=ts&"
export * from "./SecondGradAndTransferResult.vue?vue&type=script&lang=ts&"
import style0 from "./SecondGradAndTransferResult.vue?vue&type=style&index=0&id=a83f18fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83f18fe",
  null
  
)

export default component.exports